import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { AuthenticationError } from './errors';

/**
 * Handle authentication errors globally by clearing the cache
 * This ensures users are redirected to login when their session expires
 */
const handleAuthError = (error: unknown) => {
  if (error instanceof AuthenticationError) {
    queryClient.clear();
  }
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: handleAuthError,
  }),
  mutationCache: new MutationCache({
    onError: handleAuthError,
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 30 * 60 * 1000,
    },
  },
});
